import styled from 'styled-components'

export const ContactContainer = styled.div` 
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 50px;
  padding: 0 50px;
  text-align: left;
  width: 100%;

  p{
    width: 100%;
  }

    @media (max-width: 550px) {
      /* Phones */
      grid-template-columns: 1fr;
      text-align: center;
      padding: 0;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      grid-template-columns: 1fr;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 0;
    }

    @media (max-width: 1300px) {
      /* Small desktop */
    }
`

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p:nth-child(1){
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 10px;
    font-size: 1.13em;
  }

  img{
    width: 60%;

    @media (max-width: 550px) {
      /* Phones */
      width: 30%;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 30%;
    }
  }
`

export const Spacer = styled.div`
  height: 20px;
`

export const LogosContainer = styled.div`
  width: 100%;
  padding: 20px 0px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  align-items: center;
  border-top: 1px solid rgba(102, 102, 102, 1);
  border-bottom: 1px solid rgba(102, 102, 102, 1);
  justify-items: center;
  
  @media (max-width: 550px) {
    /* Phones */
    padding: 20px 70px;

    img{
      width: 32px;
    }
  }

  @media (max-width: 1100px) {
    /* Tablets */
        padding: 20px 0px;

    img{
      width: 32px;
    }
  }
`

export const CopyRightContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  color: rgba(102, 102, 102, 1);
`

export const SocialLogosContainer = styled.div`
  font-size: 1.4em;
  width: 100%;
  display: flex;
  margin-top: 12px;

  a{
    color: white;

    &:hover{
      cursor: pointer;
      color: #e4e4e4;
    }
  }

  svg{
    margin-right: 8px;
  }

  @media (max-width: 550px) {
    /* Phones */
    margin-top: 20px;
    grid-template-columns: 1fr;
    text-align: center;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin-top: 20px;
    grid-template-columns: 1fr;
    align-items: center;
    justify-content: center;
  }
`

export const ImageSection = styled.div`
  position: absolute;
  opacity: 0.1;
  margin-top: 90px;

  img{
    max-width: 70%;
  }


`

export const Container = styled.div`
  max-width: 1500px;
`